import './App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import AllCustomerPage from './pages/allCustomerPage';
import HomePage from './pages/homePage';
import Loginpage from './pages/loginPage';
import PaidCustomerpage from './pages/paidCustomerPage';
import NotPaidCustomerPage from './pages/unpaidCustomerPage';
import CreditCustomerPage from './pages/creditCustomerPage';
import GroupCustomerPage from './pages/gropuCustomerPage';
import ActiveCustomerPage from './pages/activeCustomerPage';
import DeactiveCustomer from './pages/deactivecustomerpage';
import StreetCustomerPage from './pages/streetCustomerPage';
import AddCustomerPage from './pages/addCustomerPage';
import StbReplacementPage from './pages/stbReplacementPage';
import GeneralServiceChargesPage from './pages/GeneralServiceChargesPage';
import TripSheetPage from './pages/tripsheetpage';
import GeneralExpensepage from './pages/generalexpensepage';
import TcclTopup from './pages/tccltopuppage';
import MaterialPurchase from './pages/materialpurchasepage';
import ElectricBill from './pages/electricbillpage';
import OfficeRent from './pages/officerentpage';
import UnAssignedSTB from './pages/unassignedstbpage';
import StbPurchase from './pages/stbpurchasepage';
import StbReturn from './pages/stbreturnpage';
import StbType from './pages/stbtypepage';
import SingleCustomerReportPage from './pages/singleCustomerReportPage';
import ConnectionReportPage from './pages/connectionReportPage';
import CustomerReportPage from './pages/customerReportPage';
import NetworkWiseReportPage from './pages/networkWiseReportPage';
import ReverseCustomerReportpage from './pages/reverseCustomerReportPage';
import CollectionStaffReportpage from './pages/collectionStaffsReportPage';
import AccountsReportpage from './pages/accountsReportPage';
import MonthlyReportpage from './pages/monthlyReportPage';
import StaffDetailspage from './pages/staffDetailsPage';
import AddStaffPage from './pages/addStaffPage';
import CustomerEditPage from './pages/customerEditPage';
import CustomerHistoryPage from './pages/customerHistoryPage';
import PlanDetailspage from './pages/planDetailsPgae';
import MultiPaymentPage from './pages/multiPaymentPage';
import WalletCustomerPage from './pages/walletAmountPage';
import WalletCustomerViewPage from './pages/walletCustomerViewPage';
import PaymentPage from './pages/paymentPage.jsx';
import EmployeeSalarypage from './pages/employeeSalaryPage.jsx';
import QrCodeGeneratepage from './pages/qrCodeGeneratePage.jsx';
import ExtraPaidCustomerPage from './pages/advancePaidCustomerPage.jsx';
import CurrentMonthPage from './pages/currentMonthGetInfoPage.jsx';
import NewCustomerPage from './pages/newCustomerPage.jsx';
import ReconnectionCustomerPage from './pages/reconnectionCustomerPage.jsx';
import ShiftingCustomerpage from './pages/shiftingCustomerPage.jsx';
import FreeCustomerpage from './pages/freeConnectionPage.jsx';
import CMDeactiveCustomerpage from './pages/cmDeactivePage.jsx';
import PMPaidCustomerpage from './pages/pmPaidCustomerPage.jsx';
import SmsNotificationPage from './pages/smsNotificationpage.jsx';
import TodayCollectionPage from './pages/todayCollectionPage.jsx';
import QrCodePage from './pages/qrCodePage.jsx';
import RecyclePage from './pages/recyclePage.jsx';
import Index from './components/index.jsx';
import StaffReportViewPage from './pages/staffReportViewPage.jsx';
import StreetViewPage from './pages/streetViewPage.jsx';
import TcclUploadPage from './pages/tcclUploadPage.jsx';
import UnPaidOperator from './pages/unPaidOperator.jsx';
import AdminPayment from './components/adminWebPayment.jsx';
import GroupCusViewPage from './pages/groupCusViewPage.jsx';
import GroupCusAddPage from './pages/groupCusAddPage.jsx';
import NewConnectionViewPage from './pages/newConnectionViewPage.jsx';
import WalletRecyclePage from './pages/walletRecyclePage.jsx';
import NewCustomerEditViewPage from './pages/NewCustomerEditPage.jsx';
//admin Pages
import AdminHomePage from './pages/adminhomePage';
import AdminOperatorPage from './pages/adminOperatorPager';
import AdminPaidCustomerPage from './pages/adminPaidCustomerPage';
import AdminUnpaidCustomerPage from './pages/adminUnpaidOperatorPage';
import AdminBillGeneratePage from './pages/adminBillGeneratePage';
import AddOperatorPage from './pages/adminAddOperatorPgae';


function App() {
  return (
    <BrowserRouter future={{ v7_startTransition: true }}>
      <Routes>
      <Route path='/' element={<Index />} />
        <Route path='/login' element={<Loginpage />} />
        <Route path='/home' element={<HomePage />} />
        <Route path='/allcustomer/:searchCustomer' element={<AllCustomerPage />} />
        <Route path='/paidcustomer' element={<PaidCustomerpage />} />
        <Route path='/unpaidcustomer' element={<NotPaidCustomerPage />} />
        <Route path='/creditcustomer' element={<CreditCustomerPage />} />
        <Route path='/groupcustomer' element={<GroupCustomerPage />} />
        <Route path='/activecustomer' element={<ActiveCustomerPage />} />
        <Route path='/deactivecustomer' element={<DeactiveCustomer />} />
        <Route path='/streetDetails' element={<StreetCustomerPage />} />
        <Route path='/addCustomer' element={<AddCustomerPage />} />
        <Route path='/stbreplacement' element={<StbReplacementPage />} />
        <Route path='/generalservice' element={<GeneralServiceChargesPage />} />
        <Route path='/tripsheet' element={<TripSheetPage />} />
        <Route path='/generalExpense' element={<GeneralExpensepage />} />
        <Route path='/tccltopup' element={<TcclTopup />} />
        <Route path='/materialpurchase' element={<MaterialPurchase />} />
        <Route path='/electricBill' element={<ElectricBill />} />
        <Route path='/officeRent' element={<OfficeRent />} />
        <Route path='/unassignedStb' element={<UnAssignedSTB />} />
        <Route path='/stPurchase' element={<StbPurchase />} />
        <Route path='/stbReturn' element={<StbReturn />} />
        <Route path='/stbType' element={<StbType />} />
        <Route path='/singleCustomerReport' element={<SingleCustomerReportPage />} />
        <Route path='/connectionReport' element={<ConnectionReportPage />} />
        <Route path='/customerReport' element={<CustomerReportPage />} />
        <Route path='/networkWiseReport' element={<NetworkWiseReportPage />} />
        <Route path='/reverseCustomerReport' element={<ReverseCustomerReportpage />} />
        <Route path='/collectionStaffReport' element={<CollectionStaffReportpage />} />
        <Route path='/accountsReport' element={<AccountsReportpage />} />
        <Route path='/monthlyReport' element={<MonthlyReportpage />} />
        <Route path='/staffDetails' element={<StaffDetailspage />} />
        <Route path='/addStaff' element={<AddStaffPage />} />
        <Route path='/planDetails' element={<PlanDetailspage />} />
        <Route path='/customerEdit/:id' element={<CustomerEditPage />} />
        <Route path="/customerHistory/:acc_num" element={<CustomerHistoryPage />} />
        <Route path="/multiPaymentPage" element={<MultiPaymentPage />} />
        <Route path="/walletamount" element={<WalletCustomerPage />} />
        <Route path="/walletCustomerView/:id" element={<WalletCustomerViewPage />} />
            <Route path="/newConnectionView/:id" element={<NewConnectionViewPage />} />
        <Route path="/paymentPage/:id" element={<PaymentPage />} />
        <Route path="/qrCodePage" element={<QrCodePage />} />
        <Route path="/RecyclePage" element={<RecyclePage />} />
          <Route path="/WalletRecyclePage" element={<WalletRecyclePage />} />
        <Route path="/employeeSalary" element={<EmployeeSalarypage />} />
        <Route path="/currentMonthGetInfo" element={<CurrentMonthPage />} />
        <Route path="/newCustomer" element={<NewCustomerPage />} />
        <Route path="/reconnectionCustomer" element={<ReconnectionCustomerPage />} />
        <Route path="/shiftingCustomer" element={<ShiftingCustomerpage />} />
        <Route path="/advancePaidCustomer" element={<ExtraPaidCustomerPage />} />
        <Route path="/freeCustomer" element={<FreeCustomerpage />} />
        <Route path="/CMDeactiveCustomer" element={<CMDeactiveCustomerpage />} />
        <Route path="/PMPaidCustomer" element={<PMPaidCustomerpage />} />
        <Route path="/SMSNotification" element={<SmsNotificationPage />} />
        <Route path="/TodayCollection" element={<TodayCollectionPage />} />
     
        <Route path='/adminHome' element={<AdminHomePage />} />
        <Route path='/adminOperator' element={<AdminOperatorPage />} />
        <Route path='/adminPaidCustomer' element={<AdminPaidCustomerPage />} />
        <Route path='/adminUnpaidCustomer' element={<AdminUnpaidCustomerPage />} />
        <Route path='/adminBillGenerate/:network' element={<AdminBillGeneratePage />} />
        
        <Route path='/adminAddOperator' element={<AddOperatorPage />} />
        <Route path='/unPaidOperator' element={<unPaidOperator />} />
        <Route path='/staffReportView/:area_code' element={<StaffReportViewPage />} />
        <Route path='/groupCustomerView/:customer_group' element={<GroupCusViewPage />} />
         <Route path='/groupCustomerAdd/:customer_group' element={<GroupCusAddPage />} />
        <Route path='/StreetExecutiveView/:id' element={<StreetViewPage />} />
        <Route path='/TcclUpload' element={<TcclUploadPage />} />
        <Route path='/BillPayment' element={<UnPaidOperator/>} />
        <Route path='/AdminBillPayment/:network' element={<AdminPayment/>} />
          <Route path='/NewCustomerEdit/:id' element={<NewCustomerEditViewPage/>} />
      </Routes>
    </BrowserRouter>

  );
}
export default App;
